import { createElement, useRef, useCallback, useEffect, useState } from 'react';
import { Select } from '@alifd/next';
import request from '@/utils/request';
import { isEmpty } from 'lodash-es';
const DictFilter = ({ onChange, name, fieldName, dict: dictsArray }) => {
    const dictMapRef = useRef(new Map());
    const [dataSource, setDataSource] = useState([]);
    const parentDict = dictsArray?.[0];
    const dict = dictsArray?.[dictsArray?.length - 1];
    const getCurrentDict = useCallback(async () => {
        const { content = [] } = await request.get(`/api/exchange/dictionary/type/values/${dict}`);
        return content;
    }, [dict]);
    const resaveDict = useCallback(async (dictTypeCd) => {
        const { content = [] } = await request.get(`/api/exchange/dictionary/type/parent/values/${dictTypeCd}`);
        const currentDict = await getCurrentDict();
        const dicts = content?.map(({ val, valDesc }) => ({ name: valDesc, value: val }));
        const dataSource = dicts?.filter((item) => currentDict?.find((r) => r?.val === item.value));
        setDataSource(dataSource);
        dictMapRef.current?.set(dictTypeCd, dicts);
        localStorage.setItem('dictMap', JSON.stringify(Array.from(dictMapRef.current?.entries())));
    }, [getCurrentDict]);
    const setDict = useCallback(async () => {
        const currentDict = await getCurrentDict();
        const targetDict = dictMapRef.current?.get(parentDict) || [];
        if (!isEmpty(targetDict)) {
            const dataSource = targetDict?.filter((item) => currentDict?.find((r) => r?.val === item.value));
            setDataSource(dataSource);
        }
        else {
            resaveDict(parentDict);
        }
    }, [getCurrentDict, parentDict, resaveDict]);
    useEffect(() => {
        const dictMap = new Map(JSON.parse(localStorage.getItem('dictMap')));
        dictMapRef.current = dictMap;
        if (dictMap.size === 0) {
            resaveDict(parentDict);
        }
        else {
            setDict();
        }
    }, [dict, parentDict, resaveDict, setDict]);
    const __onChange = (value) => {
        const filterValue = Array.isArray(value) ? value : [value];
        const joinStr = filterValue.join(',');
        onChange({
            operator: 'in',
            dataType: 'stringArray',
            value: joinStr,
            name,
            fieldName,
        });
    };
    return (createElement(Select, { onChange: (value) => __onChange(value), dataSource: dataSource?.map(({ name: label, value }) => ({ label, value })), style: { width: '100%' }, hasClear: true, mode: "multiple", showSearch: true }));
};
export default DictFilter;
